import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
	name: 'safeUrl'
})
export class SafeUrlPipe implements PipeTransform {
	constructor(private domSanitizer: DomSanitizer) {}
	transform(url: string, resourceType: boolean = true): any {
		return resourceType
			? this.domSanitizer.bypassSecurityTrustResourceUrl(url)
			: this.domSanitizer.bypassSecurityTrustHtml(url);
	}
}
